import * as React from 'react';
import { Beak, FlexLine } from './parts';
import { ISeparatorProps } from './separator.types';

export function Separator(props: ISeparatorProps) {
    const { orientation = 'vertical', hideBeak, ...rest } = props;
    return (
        <FlexLine orientation={orientation} {...rest}>
            {hideBeak ? null : <Beak
                color={props.color}
                beakColor={props.beakColor}
                orientation={props.orientation}
                inverseBeak={props.inverseBeak} />}
        </FlexLine>
    );
}
